import {DataGridProps} from './DataGridProps';

export type LoadingCellRendererProps = {
  gridProps: DataGridProps;
};
